import { ApiResponse, postRequest } from "@/data/apiClient";

export interface SsoInitResponse {
  ok: boolean;
  errorMessage: string;
  directory: string;
  description: string;
  authorizeEndpoint: string;
  parameters: SsoParameters;
}

export interface SsoParameters {
  [key: string]: string;
}

export async function preLogin(
  clientKey: string | undefined,
  userName: string,
  callbackUrl: string,
  returnUrl: string
): Promise<ApiResponse<SsoInitResponse>> {
  return postRequest("user/ssoInit", {
    clientKey,
    userName,
    callbackUrl,
    returnUrl,
  });
}

export const ssoInit = async (
  app?: string | undefined
): Promise<ApiResponse<SsoInitResponse>> => postRequest("ssoInit", { app });
